import React, { cloneElement } from 'react';
// import { Navigate, useLocation } from "react-router-dom";
import { Navigate, useLocation, useParams } from 'react-router-dom';
// import { useAppContext } from "../../utils/content.util";
import HeaderComponent from '../header/header.component';
import FooterComponent from '../footer/footer.component';
import { useAppContext } from '../../utils/content.util';

// function querystring(name: string, url = window.location.href) {
//   const parsedName = name.replace(/[[]]/g, '\\$&');
//   const regex = new RegExp(`[?&]${parsedName}(=([^&#]*)|&|#|$)`, 'i');
//   const results = regex.exec(url);

//   if (!results || !results[2]) {
//     return false;
//   }

//   return decodeURIComponent(results[2].replace(/\+/g, ' '));
// }

export default function UnauthenticatedRoute(props: any) {
  const { isAuthenticated } = useAppContext();
  const { children } = props;
  // const redirect = querystring("redirect");

  const { pathname } = useLocation();
  const { dealerId } = useParams();

  const shouldHideHeaderFooter =
    pathname === '/login' ||
    pathname === '/reset-password' ||
    pathname === '/partner-service-form' ||
    pathname === '/contracting' ||
    pathname.startsWith('/contracting/');

  if (isAuthenticated && (pathname === '/login' || pathname === '/')) {
    return <Navigate to="/dashboard" />;
  }

  // if (isAuthenticated) {
  //   return <Navigate to={redirect || "/service-forms"} />;
  // }

  return (
    <>
      {shouldHideHeaderFooter ? <></> : <HeaderComponent />}
      {cloneElement(children, props)}
      {shouldHideHeaderFooter ? <></> : <FooterComponent />}
    </>
  );
}
